import logoVariants from '@/assets/img/logo';
import { motion, useAnimation } from 'framer-motion';
import { useEffect } from 'react';

const LogoSpinner = ({
  isLoading = true,
  size = '80px',
  variant = 'dark',
}: {
  isLoading?: boolean;
  size?: string;
  variant?: 'dark' | 'light';
}) => {
  const controls = useAnimation();

  useEffect(() => {
    if (isLoading) {
      controls.start({
        rotate: 360,
        transition: {
          ease: 'linear',
          duration: 2,
          repeat: Infinity,
        },
      });
    } else {
      controls.stop();
    }
  }, [isLoading, controls]);

  return (
    <motion.img
      src={variant === 'dark' ? logoVariants.purpleNoText160x160 : logoVariants.whiteNoText160x160}
      alt="Logo"
      width={size}
      height={size}
      animate={controls}
    />
  );
};
export default LogoSpinner;
